"use strict";
var FromObservable_1 = require('./FromObservable');
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/observable/from.js
// module id = ./node_modules/rxjs/observable/from.js
// module chunks = vendor